import { render, staticRenderFns } from "./LoginComponentManagementPortals.vue?vue&type=template&id=00fe2b84&scoped=true"
import script from "./LoginComponentManagementPortals.vue?vue&type=script&lang=js"
export * from "./LoginComponentManagementPortals.vue?vue&type=script&lang=js"
import style0 from "./LoginComponentManagementPortals.vue?vue&type=style&index=0&id=00fe2b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe2b84",
  null
  
)

export default component.exports